import { contentfulPageType } from 'types';
import rollbar from 'utils/rollbar';
import { getPageBySlug } from 'lib/contentful';
import NotFound from 'pages/404';
import Layout from 'layouts';
import { Head } from 'humanity/components/head';
import Section from 'legacy/components/section';
import SimpleRichText from 'legacy/components/humanity-v1/primitives/simpleRichText';

const Disclosures = ({ page }) => {
  if (!page) return <NotFound />;

  return (
    <Layout layout={page.layout}>
      <Head
        title={page.seoMetadata?.title}
        description={page.seoMetadata?.description}
        url={`${process.env.NEXT_PUBLIC_HI_BASE_URL}${page.seoMetadata?.canonicalUrl}`}
        noIndex={page.seoMetadata?.noIndex}
      />
      <Section>
        <Section.Inner>
          <SimpleRichText content={page.sectionsCollection?.items[0]?.content?.json} />
        </Section.Inner>
      </Section>
    </Layout>
  );
};

Disclosures.propTypes = {
  page: contentfulPageType.isRequired,
};

export const getStaticProps = async ({ preview = false }) => {
  const SLUG = 'disclosures';

  try {
    const sectionsFields = `
      ... on TextBlock {
        content {
          json
        }
      }
    `;

    const page = await getPageBySlug(SLUG, sectionsFields, preview);

    return { props: { page }, revalidate: 900 };
  } catch (err) {
    rollbar.error(`Error fetching ${SLUG} page`, err, err.response?.data);
    throw new Error(`Error fetching ${SLUG} page`, { cause: err });
  }
};

export default Disclosures;
